export const EDITABLE_TABLE_NAMESPACE = 'ewd';
export const READ_ONLY_TABLE_NAMESPACE = 'wrod';
